import React from 'react'
import {Route, BrowserRouter, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux';

import {Home, Start, Dashboard, SubjectChange, RoleChange, NotFoundPage, End } from 'components';
import {IzjavaPristupacnosti} from "../components/IzjavaPristupacnosti";

const RoutesComponent = () => {
  
  const isImpaired = useSelector((state) => state.layout.isImpaired);
  const fontSize = useSelector(state => state.layout.fontSize);

  if(isImpaired){
    document.body.style.backgroundColor = "#000";
  }else{
      document.body.style.backgroundColor = "#fff";
  }
  return (
    <div className={`${isImpaired ? "visionImpaired" : ""} font${fontSize}`}>
      <BrowserRouter basename="/">
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/loged" element={<Start/>} />
          <Route path="/logedout" element={<End/>} />
          <Route path="/dash" element={<Dashboard/>} />
          <Route path="/e-ovlastenja-front/promjena-subjekta/ForPersonOib/:forPersonOib/ForLegalIps/:forLegalIps/ForLegalIzvor_reg/:forLegalIzvor/ToLegalIps/:toLegalIps/ToLegalIzvor_reg/:toLegalIzvor" exact element={<SubjectChange />}/>
          <Route path="/authorities/:authorities/subject/:subject" element={<RoleChange />} />
          <Route path="/izjava-pristupacnosti" element={<IzjavaPristupacnosti />}/>
          <Route path="*" element={<NotFoundPage />}/>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default RoutesComponent
